<template>
  <div
    class="card !border-none !bg-transparent !p-1 m-0"
    style="width: 100%"
    v-loading="loading"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <h3 class="text-black-950 !font-normal text-sm 2xl:!text-base !m-0 !pb-4">
      Dashboard Statistics
    </h3>

    <div class="stats-list sidemenu">
      <div v-for="(stat, index) in dashboardStatics" :key="index" class="stat-item">
        <div class="single-stat">
          <el-row type="flex">
            <el-col>
              <label class="text-black-700" for="allDocuments">{{ stat.title }}</label>
            </el-col>
            <el-col>
              <el-switch
                v-model="stat.status"
                id="allDocuments"
                active-text="ON"
                inactive-text="OFF"
                @change="saveDashboardStats"
                active-color="var(--brand-500)"
                inactive-color="var(--black-200)"
              ></el-switch>
            </el-col>
          </el-row>
        </div>
        <el-divider class="stat-divider my-1"></el-divider>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'Dashboard-Stats',
    async mounted() {
      this.loading = true;
      await this.fetchUserdashboardStatics();
      await this.setData();
      this.loading = false;
    },
    computed: {
      ...mapGetters('settings', [
        'getUserDashboardStastics',
        'getUpdateUserDashboardStaticsStatus',
      ]),
    },
    methods: {
      async fetchUserdashboardStatics() {
        await this.$store.dispatch('settings/fetchUserDashboardStatics');
      },
      setData() {
        if (this.getUserDashboardStastics) {
          this.dashboardStatics = this.getUserDashboardStastics.data;
        }
      },
      async saveDashboardStats() {
        if (this.dashboardStatics) {
          let dashboardStatics = {};
          dashboardStatics.dashboard_stats = this.dashboardStatics;
          await this.$store.dispatch('settings/updateUserDashboardStatics', dashboardStatics);
          if (this.getUpdateUserDashboardStaticsStatus) {
            this.$notify.success({
              title: 'Success',
              message: 'Dashboard Stats settings updated successfully',
            });
          } else {
            this.$notify.error({
              title: 'Error',
              message: 'Error in updating the Dashboard Status settings',
            });
          }
        }
      },
    },
    data() {
      return {
        documentStatics: {},
        allDocuments: true,
        allTemplates: true,
        allApproval: true,
        sentDocs: true,
        viewedDocs: true,
        completedDocs: false,
        loading: false,
        dashboardStatics: [],
      };
    },
    beforeDestroy() {
      this.$store.commit('settings/setUserDashboardStastics', null, {
        root: true,
      });
      this.$store.commit('settings/setUpdateUserDashboardStaticsStatus', null, {
        root: true,
      });
    },
  };
</script>

<style lang="scss" scoped>
  .sidemenu {
    height: calc(100vh - 200px);
    overflow-y: auto;
    overflow-x: auto;
    scrollbar-width: thin;
    border: 1px ridge;
  }
  .sidemenu::-webkit-scrollbar {
    width: 0.7em;
  }
  .sidemenu::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    background: #e1e1e1;
    -webkit-box-shadow: inset 0 0 6px rgba(172, 169, 169, 0.9);
  }
  .sidemenu::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px #f5f5f5;
    background-color: #f5f5f5;
  }
  .stats-list {
    // padding: 0.5rem !important;
    // border-radius: 12px !important;
    border: 0 !important;
    .single-stat {
      padding: 0.5em 0.5em;
    }
    .stat-item:last-child {
      .stat-divider {
        display: none;
      }
    }
    .stat-item {
      .stat-divider {
        color: var(--page-border);
        border-color: var(--page-border);
        background: var(--page-border);
      }
    }
  }
</style>
